<template>
  <div class="wrapper">
    <div class="wrapper-header"></div>
    <div class="wrapper-body">
      <div class="wrapper-body-content">
         <span class="result-title">恭喜您!</span>
        <p class="notes">
          获得一套安全课程，快去APP观看吧！
        </p>
        <div class="course-box">
          <div class="course-box-border"></div>
          <div class="course-box-cover">
            <div class="course-box-cover-shadow"></div>
            <!-- <img
              src="https://rskjy.oss-cn-beijing.aliyuncs.com/default/d6ed8a7fbe5f7efeb40c20c5e31c8a13.png?x-oss-process=image/resize,w_600"
            /> -->
            <div class="fail-box">
              <img
              src="@assets/img/gift/end@2x.png"
            /> 
            </div>
          </div>
        </div>
        <p class="result-message">
          课程套餐已成功放入185****9649账户，请到“个人中心-分享赚钱-获赠课程”中领取观看
        </p>
        <button class="receive web-font">去APP观看</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "results",
  data() {
    return {
      userName: "睿识课",
      coverImgUrl: "",
      failImgUrl: require('@assets/img/gift/end@2x.png'),
      title: "",
      phone:'18511331234',
      invoiceTypeList: [
        { id: 1, title: '恭喜您!',notes:'获得一套安全课程，快去APP观看吧！',message:'课程套餐已成功放入'+ this.phone  +'账户，请到“个人中心-分享赚钱-获赠课程”中领取观看' },
        { id: 2, title: '已领完',notes:'很遗憾，课程被抢光了，下次早点来哦～',message:'好友分享的课程领完了，去APP看看吧' },
        { id: 3, title: '领取重复',notes:'您已领取过此套精品课程，不可重复领取。',message:'请在APP“个人中心”-”分享赚钱“-“获赠课程”中领取观看' },
        { id: 4, title: '已拥有',notes:'您已拥有此套精品课程，不可重复领取。',message:'请在APP“我的课程”中观看' },
      ]
    };
  },
  mounted() {
  },
  components: {},
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrapper
{
  position: relative;

  display: flex;
  overflow: hidden;
  flex-direction: column;

  width: 100%;
  height: 603px;

  background: linear-gradient(180deg, #fec6a7 0%, #ffe8da 41%, #ffc3af 67%, #ffd5bf 100%);
  &-header
  {
    position: absolute;
    top: 6px;
    left: 6.5px;

    width: calc(100% - 11px);
    height: 44px;

    background: url(~@assets/img/gift/cloud_small@2x.png) no-repeat center;
    background-size: 100% 100%;
  }
  &-body
  {
    position: relative;

    width: 100%;
    height: 523px;
    &-content
    {
      display: flex;
      align-items: center;
      flex-direction: column;

      width: 332px;
      height: 523px;
      margin: 0 auto;
      margin-top: 40.07px;

      background: url(~@assets/img/gift/gift@2x.png) no-repeat center;
      background-size: 100% 100%;
      .result-title
      {
        font-family: FZZCHJW--GB1-0, FZZCHJW--GB1;
        font-size: 30px;
        font-weight: 600;
        line-height: 37px;

        width: 100%;
        height: 37px;
        margin-top: 35.93px;

        text-align: center;

        color: #fff;
      }
      .notes
      {
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;

        width: 239px;
        height: 20px;
        margin: 61px 0 0 0;

        color: #fff9cf;
      }
      .course-box
      {
        position: relative;

        width: 298px;
        height: 163px;
        margin-top: 20px;
        &-border
        {
          box-sizing: border-box;
          width: 298px;
          height: 34px;

          border: 8px solid #ee9c45;
          border-radius: 6px;
          background: #631a0a;
        }
        &-cover
        {
          position: absolute;
          top: 7px;
          left: 13px;

          width: 272px;
          height: 153px;
          &-shadow
          {
            position: absolute;
            top: 0;
            left: 0;

            width: 272px;
            height: 43px;

            opacity: .75;
            border-radius: 1px;
            background: linear-gradient(
            180deg,
            rgba(0, 0, 0, .45) 0%,
            rgba(255, 255, 255, 0) 100%
            );
          }
          img
          {
            width: 100%;
            height: 100%;
          }
          .fail-box
          {
            display: flex;
            align-items: center;
            justify-content: center;

            width: 100%;
            height: 100%;

            background: #fff;
            img
            {
              width: 137px;
              height: 108px;
            }
          }
        }
      }
      .result-message
      {
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;

        width: 272px;
        height: 34px;
        margin-top: 20px;

        text-align: center;

        color: #ffcfac;
      }
      .receive
      {
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 22px;
        font-weight: 500;
        line-height: 40px;

        width: 180px;
        height: 40px;
        margin-top: 40px;

        letter-spacing: 1px;

        color: #741920;
        border: none;
        border-radius: 20px;
        background: linear-gradient(180deg, #fbef6f 0%, #f0af3d 100%);
        &:focus
        {
          margin: 96px 0 0 0;

          outline: none;
        }
      }
    }
  }
}

</style>
